export default __webpack_public_path__ + "static/char-33-anr-339adcaf1826ba05b15ba06f0d2d2ef2.webp";